import React from "react"
import ZdqConnectorStatus from "../../components/ZdqConnectorStatus"
import { GENERIC_POSTGRES } from "../../Constants"

function ZdqGenericPostgresConnectorStatus() {
    return <ZdqConnectorStatus vendor={GENERIC_POSTGRES}></ZdqConnectorStatus>
}

export default ZdqGenericPostgresConnectorStatus